import { useEffect, useState } from 'react';
import SEO from '../components/common/SEO';
import { collegeApi, preloadCollegeAssets } from '../components/college/shared';
import { MotionStyles, Aurora } from '../components/college/shared';
import { CollegeGate } from '../components/college/CollegeGate';
import { CollegeNav } from '../components/college/CollegeNav';
import { Hero, Opportunity, Education, Journey } from '../components/college/SectionsCore';
import { Campus, Originals, Industry } from '../components/college/SectionsCampus';
import { Qualification, OperatingModel, Sustainability } from '../components/college/SectionsHub';
import { Growth, Roadmap, Impact, Partnerships } from '../components/college/SectionsClose';

const NAV_MAP = { vision: 'vision', opportunity: 'vision', education: 'education', journey: 'journey', campus: 'campus', qualification: 'qualification', model: 'model', sustainability: 'model', originals: 'originals', industry: 'industry', growth: 'growth', roadmap: 'growth', impact: 'partnerships', partnerships: 'partnerships' };

export default function CollegePartners() {
  const [unlocked, setUnlocked] = useState(() => !!sessionStorage.getItem('upa_college_token'));
  const [active, setActive] = useState('vision');

  useEffect(() => {
    if (!unlocked) return;
    preloadCollegeAssets();
    let current = 'vision';
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          const id = e.target.getAttribute('data-college-section');
          current = id;
          setActive(NAV_MAP[id] || id);
        }
      });
    }, { rootMargin: '-40% 0px -50% 0px' });
    document.querySelectorAll('[data-college-section]').forEach((el) => obs.observe(el));

    const ping = () => collegeApi.post('/college/ping', { section: current }).catch((err) => {
      if (err.response?.status === 401) { sessionStorage.removeItem('upa_college_token'); setUnlocked(false); }
    });
    ping();
    const interval = setInterval(ping, 20000);
    return () => { obs.disconnect(); clearInterval(interval); };
  }, [unlocked]);

  return (
    <div style={{ background: '#050505' }} className="min-h-screen">
      <SEO title="UPA College — Private Presentation" description="Private partnership presentation." noIndex />
      {!unlocked ? (
        <CollegeGate onUnlock={() => setUnlocked(true)} />
      ) : (
        <main data-testid="college-presentation" className="relative">
          <MotionStyles />
          <Aurora />
          <div className="relative z-10">
          <CollegeNav active={active} />
          <Hero />
          <Opportunity />
          <Education />
          <Journey />
          <Campus />
          <Qualification />
          <OperatingModel />
          <Sustainability />
          <Originals />
          <Industry />
          <Roadmap />
          <Growth />
          <Impact />
          <Partnerships />
          <footer className="px-6 py-10 text-center border-t border-white/10">
            <p className="text-white/35 text-xs leading-relaxed max-w-2xl mx-auto">
              © Universal Performing Arts. Private &amp; confidential — shared for exploratory partnership discussions only.
              Strategic concept proposal, subject to educational partnerships, feasibility, funding and relevant approvals.
            </p>
          </footer>
          </div>
        </main>
      )}
    </div>
  );
}
